import { ValueOf } from '../../types/interfaces'
import { pick } from '../../utils/utils';
import { Colors } from '../../core/constants/colors';
import {Sizes} from "../../core/constants/sizes";

export const IconSizes = pick(Sizes, ['_XS', '_S', '_M', '_L', '_XL', '_2XL', '_3XL', '_4XL', '_5XL'])
export type IconSizesType = `${ValueOf<typeof IconSizes>}`

export const IconColors = pick(Colors, [
	'DEFAULT',
	'PRIMARY',
	'SECONDARY',
	'NEUTRAL',
	'ERROR',
	'SUCCESS',
	'WARNING',
	'DISABLED',
	'WHITE',
	'BLACK',
])
export type IconColorType = `${ValueOf<typeof IconColors>}`

enum Types {
	BASIC = 'basic',
	COMPLEX = 'complex',
	COLORED = 'colored',
}
export type Type = `${ValueOf<typeof Types>}`

export const IconClass = {
	root: 'gov-icon',
	holder: 'gov-icon__holder',
}
